import { z } from "zod";
import { FinancialAccountType } from "@common/types/financialAccount";
import { ExtractionStatus } from "@common/types/financialDocument";

export const AccountInfoExtractionSchema = z.object({
    accountNumber: z.string().nullable(),
    institutionName: z.string().nullable(),
    accountType: z.nativeEnum(FinancialAccountType).nullable(),
    accountName: z.string().nullable(),
    status: z.nativeEnum(ExtractionStatus),
});

export type AccountInfoExtraction = z.infer<typeof AccountInfoExtractionSchema>;
